const staticAppUrl = window.location.origin.includes("localhost") ? "http://localhost:3000" : "https://www.apispreadsheets.com";

export default staticAppUrl;